// extracted by mini-css-extract-plugin
module.exports = {"root":"FourTile_root__k6Veh","contentTiles":"FourTile_contentTiles__hKLFQ"};